module.exports = __webpack_public_path__ + "static/img/1.e85cb57b.png";